import React from "react";
import congratsImg from "../Assets/imgs/landing/congraution.png";

interface SubscriptionSuccesPopUpProps {
  onHidejcSuccessModal: () => void;
}

const SubscriptionSuccesPopUp = ({
  onHidejcSuccessModal,
}: SubscriptionSuccesPopUpProps) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <img src={congratsImg} alt="congratulations" style={styles.image} />
        <h2 style={styles.title}>Congratulations</h2>
        <p style={styles.subtitle}>
          Aap kamyabi k saath Jhoom ka hissa ban chukay hain.
        </p>
        <button style={styles.button} onClick={onHidejcSuccessModal}>
          Ok
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  card: {
    background: "linear-gradient(145deg, #1a1a3e, #0d0d1f)",
    border: "1px solid rgba(123, 47, 247, 0.4)",
    borderRadius: "24px",
    padding: "40px 32px 32px",
    maxWidth: "340px",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0 0 40px rgba(123, 47, 247, 0.25), 0 8px 32px rgba(0,0,0,0.5)",
  },
  image: {
    width: "90px",
    height: "90px",
    objectFit: "contain",
    marginBottom: "20px",
    filter: "drop-shadow(0 0 12px rgba(123, 47, 247, 0.6))",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#ffffff",
    margin: "0 0 12px",
    letterSpacing: "0.3px",
  },
  subtitle: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.65)",
    lineHeight: 1.7,
    margin: "0 0 28px",
  },
  button: {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(90deg, #7b2ff7, #b44fff)",
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    border: "none",
    borderRadius: "14px",
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(123, 47, 247, 0.5)",
  },
};

export default SubscriptionSuccesPopUp;
